export const environment = {
    production: false,
    BASE_API: 'https://template-be-production.up.railway.app'
};